// An element's rendered width, kept current as it resizes. Progress draws
// its SVG charts at their real pixel width (not a scaled viewBox), so the
// axis text stays 11 px on a phone and on a desktop alike. Kept out of the
// component files (react-refresh).
import { useLayoutEffect, useState } from "react";

/**
 * The width of `ref.current` in whole pixels; `fallback` until it has been
 * measured, and where nothing can measure it (no layout: jsdom, a
 * thumbnail). Without ResizeObserver it is measured once.
 */
export function useElementWidth(ref, fallback = 320) {
  const [width, setWidth] = useState(fallback);
  useLayoutEffect(() => {
    const node = ref.current;
    if (!node) return undefined;
    const measure = () => {
      const measured = Math.round(node.getBoundingClientRect().width);
      if (measured > 0) setWidth(measured);
    };
    measure();
    if (typeof ResizeObserver === "undefined") return undefined;
    const observer = new ResizeObserver(measure);
    observer.observe(node);
    return () => observer.disconnect();
  }, [ref]);
  return width;
}
